import {
  ALIGN_ITEMS_LEFT,
  ALIGN_ITEMS_CENTER,
  ALIGN_ITEMS_RIGHT,
} from "../../../actions/index";

const initialState = {};

export default function (state = initialState, action) {
  switch (action.type) {

    case ALIGN_ITEMS_LEFT:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (
            old_layer.width > 0 &&
            (old_layer.allow_image || old_layer.allow_text)
          ) {
            const selectedTextElements = old_layer.text_elements.filter((obj) => obj.is_selected),
                  selectedImageElements = old_layer.image_elements.filter((obj) => obj.is_selected),
                  selectedElements = [...selectedTextElements, ...selectedImageElements];

            if (selectedElements.length === 0) {
              return old_layer;
            }

            const keyElement = selectedElements.find((obj) => obj.is_key_element);
            let baseLeftPosition,
                baseTextLeftPosition,
                baseImageLeftPosition;

            if (keyElement) {
              baseLeftPosition = keyElement.left_position;
            } else {
              if (selectedElements.length === 1) {

                // Get the furthest left positioned text element
                baseTextLeftPosition = Math.min.apply(
                  Math,
                  old_layer.text_elements.map((obj) => {
                    return obj.left_position;
                  }),
                );

                // Get furthest left positioned image element
                baseImageLeftPosition = Math.min.apply(
                  Math,
                  old_layer.image_elements.map((obj) => {
                    return obj.left_position;
                  }),
                );

                // Assign the base left position for all elements to the lowest left position value of both images and text
                baseLeftPosition =
                  baseTextLeftPosition < baseImageLeftPosition
                    ? baseTextLeftPosition
                    : baseImageLeftPosition;

                if (baseLeftPosition < 0) {
                  baseLeftPosition = 0;
                }

              } else {
                baseTextLeftPosition = selectedTextElements.length > 0
                  ? Math.min(...selectedTextElements.map((obj) => obj.left_position))
                  : Infinity;

                baseImageLeftPosition = selectedImageElements.length > 0
                  ? Math.min(...selectedImageElements.map((obj) => obj.left_position))
                  : Infinity;

                baseLeftPosition = Math.min(baseTextLeftPosition, baseImageLeftPosition);

                if (baseLeftPosition < 0 || baseLeftPosition === Infinity) {
                  baseLeftPosition = 0;
                }
              }
            }

            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => {
                if (element.is_selected && !element.is_key_element) {
                  return {
                    ...element,
                    left_position: baseLeftPosition,
                  };
                }
                element.is_key_element = false;
                return element;
              }),
              image_elements: old_layer.image_elements.map((element) => {
              if (element.is_selected && !element.is_key_element) {
                  return {
                    ...element,
                    left_position: baseLeftPosition,
                  };
                }
                element.is_key_element = false;
                return element;
              }),
            };
          } else {
            return {
              ...old_layer,
            };
          }
        }),
      };

    case ALIGN_ITEMS_CENTER:
      return {
        ...state,
        layer_set: state.layer_set.map((old_layer) => {
          if (
            old_layer.width > 0 &&
            (old_layer.allow_image || old_layer.allow_text)
          ) {
            const selectedTextElements = old_layer.text_elements.filter((obj) => obj.is_selected),
                  selectedImageElements = old_layer.image_elements.filter((obj) => obj.is_selected),
                  selectedElements = [...selectedTextElements, ...selectedImageElements];

            if (selectedElements.length === 0) {
              return old_layer;
            }

            const keyElement = selectedElements.find((obj) => obj.is_key_element);
            let baseLeftPosition,
                baseWidth;

            if (keyElement) {
              baseLeftPosition = keyElement.left_position;
              baseWidth = keyElement.width;
            } else {
              if (selectedElements.length === 1) {
                    // Get furthest left positioned text element
                const baseTextWidth = Math.max.apply(
                  Math,
                  old_layer.text_elements.map((obj) => {
                    return obj.width;
                  }),
                );

                const baseImageWidth = Math.max.apply(
                  Math,
                  old_layer.image_elements.map((obj) => {
                    return obj.width;
                  }),
                );

                // Get furthest left positioned text element
                const baseTextLeftPosition = Math.min.apply(
                  Math,
                  old_layer.text_elements.map((obj) => {
                    return obj.left_position;
                  }),
                );

                // Get furthest left positioned image element
                const baseImageLeftPosition = Math.min.apply(
                  Math,
                  old_layer.image_elements.map((obj) => {
                    return obj.left_position;
                  }),
                );

                // Assign the base left position for all elements to the lowest left position value of both images and text
                baseLeftPosition =
                  baseTextLeftPosition < baseImageLeftPosition
                    ? baseTextLeftPosition
                    : baseImageLeftPosition;

                if (baseLeftPosition < 0) {
                  baseLeftPosition = 0;
                }

                // Assign the base left position for all elements to the lowest left position value of both images and text
                baseWidth =
                  baseTextWidth > baseImageWidth ? baseTextWidth : baseImageWidth;
              } else {
                const baseTextWidth = selectedTextElements.length > 0
                  ? Math.min(...selectedTextElements.map((obj) => obj.width))
                  : 0;

                const baseImageWidth = selectedImageElements.length > 0
                  ? Math.min(...selectedImageElements.map((obj) => obj.width))
                  : 0;

                const baseTextLeftPosition = selectedTextElements.length > 0
                ? Math.min(...selectedTextElements.map((obj) => obj.left_position))
                : Infinity;

                const baseImageLeftPosition = selectedImageElements.length > 0
                  ? Math.min(...selectedImageElements.map((obj) => obj.left_position))
                  : Infinity;


                baseLeftPosition = Math.min(baseTextLeftPosition, baseImageLeftPosition);

                if (baseLeftPosition < 0 || baseLeftPosition === Infinity) {
                  baseLeftPosition = 0;
                }

                // Assign the base left position for all elements to the lowest left position value of both images and text
                baseWidth = Math.max(baseTextWidth, baseImageWidth);
            }
          }

            return {
              ...old_layer,
              text_elements: old_layer.text_elements.map((element) => {
                if (element.is_selected && !element.is_key_element) {
                  return {
                    ...element,
                    left_position:
                      baseLeftPosition + (baseWidth / 2 - element.width / 2),
                  };
                }
                element.is_key_element = false;
                return element;
              }),
              image_elements: old_layer.image_elements.map((element) => {
                if (element.is_selected && !element.is_key_element) {
                  return {
                    ...element,
                    left_position:
                      baseLeftPosition + (baseWidth / 2 - element.width / 2),
                  };
                }
                element.is_key_element = false;
                return element;
              }),
            };
          } else {
            return {
              ...old_layer,
            };
          }
        }),
      };

      case ALIGN_ITEMS_RIGHT:
        return {
          ...state,
          layer_set: state.layer_set.map((old_layer) => {
            if (
              old_layer.width > 0 &&
              (old_layer.allow_image || old_layer.allow_text)
            ) {
              const selectedTextElements = old_layer.text_elements.filter((obj) => obj.is_selected),
                    selectedImageElements = old_layer.image_elements.filter((obj) => obj.is_selected),
                    selectedElements = [...selectedTextElements, ...selectedImageElements];

              if (selectedElements.length === 0) {
                return old_layer; // No selected elements, return the layer unchanged
              }

              const keyElement = selectedElements.find((obj) => obj.is_key_element);

              let baseRightPosition;
              const layerWidth = old_layer.width;

              if (keyElement) {
                baseRightPosition = keyElement.left_position + keyElement.width;
              } else {
                  const baseTextRightPosition = old_layer.text_elements.length > 0
                    ? Math.max(...old_layer.text_elements.map((obj) => obj.left_position + obj.width))
                    : 0;

                  const baseImageRightPosition = old_layer.image_elements.length > 0
                    ? Math.max(...old_layer.image_elements.map((obj) => obj.left_position + obj.width))
                    : 0;

                  baseRightPosition = Math.max(baseTextRightPosition, baseImageRightPosition);
              }

              return {
                ...old_layer,
                text_elements: old_layer.text_elements.map((element) => {
                  if (element.is_selected && !element.is_key_element) {
                    let newLeft = baseRightPosition - element.width;

                    if (newLeft + element.width > layerWidth) {
                      newLeft = layerWidth - element.width;
                    }

                    return {
                      ...element,
                      left_position: newLeft,
                    };
                  }
                  element.is_key_element = false;
                  return element;
                }),
                image_elements: old_layer.image_elements.map((element) => {
                  if (element.is_selected && !element.is_key_element) {
                    let newLeft = baseRightPosition - element.width;

                    if (newLeft + element.width > layerWidth) {
                      newLeft = layerWidth - element.width;
                    }

                    return {
                      ...element,
                      left_position: newLeft,
                    };
                  }
                  element.is_key_element = false;
                  return element;
                }),
              };
            } else {
              return {
                ...old_layer,
              };
            }
          }),
        };

    default:
      return state;
  }
}
